/**
 * don't change import order
 * ['.dotenv', './js/nclk.js']
 */
import './dotenv'
import './js/lcslog.js'
import { MOBILE_REGEX } from '@Root/contants'

function lcs(_params: any) {
  return _params.lcs_do(_params)
}

export default lcs

const getSti = () => {
  if (MOBILE_REGEX.IS_PAY_APP.test(navigator.userAgent)) {
    return 'm_payapp'
  }
  return ''
}

export const lcsSend = (param: string) => {
  const oDate = new Date()
  const sRnd = (oDate.getTime() + '').replace(/0/gi, 'o').replace(/1/gi, 'l').replace(/2/gi, 'e')
  const sti = getSti()

  const target: HTMLElement | null = document.getElementById('pvframe')
  const element = document.createElement('iframe')
  element.id = 'writeFrame'
  element.width = '0'
  element.height = '0'
  element.frameBorder = '0'
  element.scrolling = 'no'
  element.src = `/ndscheck.html?p=${param}&sti=${sti}&rnd=${sRnd}`
  target?.appendChild(element)
}
